export const FETCH_REGIONS_REQUEST = 'FETCH_REGIONS_REQUEST'
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS'
export const FETCH_BANKS_REQUEST = 'FETCH_BANKS_REQUEST'
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS'
export const FETCH_COMMUNES_REQUEST = 'FETCH_COMMUNES_REQUEST'
export const FETCH_COMMUNES_SUCCESS = 'FETCH_COMMUNES_SUCCESS'
export const FETCH_CITYS_REQUEST = 'FETCH_CITYS_REQUEST'
export const FETCH_CITYS_SUCCESS = 'FETCH_CITYS_SUCCESS'
export const ACTIVE_STEP = 'ACTIVE_STEP'
export const DEACTIVATE_STEP = 'DEACTIVATE_STEP'
export const TESTUTILS = 'TESTUTILS'
